import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import Button from "@/components/base/Button";

const quickLinks = [
  { label: "About Us", to: "/about" },
  { label: "All Services", to: "/services" },
  { label: "Spine Care", to: "/services/spine-care" },
  { label: "Orthopaedic Care", to: "/services/orthopaedic-care" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export default function NotFound() {
  return (
    <Layout>
      <Seo
        title="Page Not Found | Ortho Spine Care"
        description="The page you are looking for could not be found. Explore our orthopaedic and spine care services and conditions, or book an appointment."
        path="/404"
      />
      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
          <p className="font-heading text-6xl font-semibold leading-none text-primary-200 md:text-8xl">404</p>
          <h1 className="mt-5 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            We couldn&apos;t find that page
          </h1>
          <p className="mx-auto mt-3 max-w-lg font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            The page you are looking for may have been moved or no longer exists. Explore our services, or book an
            appointment with our orthopaedic and spine specialist.
          </p>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Button to="/" icon="ri-home-line">
              Back to Home
            </Button>
            <Button to="/appointment" variant="outline" icon="ri-calendar-check-line">
              Book Appointment
            </Button>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {quickLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="font-label text-sm font-semibold text-foreground-600 transition-colors hover:text-primary-700"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}